import { color, margins } from '@olist/styled-system';
import styled, { css } from 'styled-components';

const CardComponent = styled.div(({ theme: { olist: { components: { card }, }, }, direction = 'column', variation, href, onClick, borderDirection, borderColor, maxWidth, }) => css `
    flex-direction: ${direction};
    position: relative;
    border-radius: ${card.radius};
    ${maxWidth &&
    css `
      max-width: ${maxWidth};
    `}

    ${variation
    ? css `
          background-color: ${card.variation[variation]};
        `
    : css `
          background-color: ${card['background-color']};
          border: ${card['border-width']} solid ${card['border-color']};
        `}

    ${!variation &&
    borderColor &&
    borderDirection &&
    css `
      background-image: linear-gradient(
        to
          ${(borderDirection === 'left' && 'right') ||
        (borderDirection === 'bottom' && 'top')},
        ${card.border[borderColor]} 8px,
        transparent 8px,
        transparent 100%
      );
    `}

    ${(href || onClick) &&
    css `
      text-decoration: none;
      &:hover {
        cursor: pointer;
        box-shadow: ${card['box-shadow']};
      }
    `}

    ${direction &&
    css `
      display: flex;
      ${Image} {
        ${direction === 'row'
        ? css `
              border-right: ${card['border-width']} solid
                ${card['border-color']};
              border-top-left-radius: calc(${card.radius} - 1px);
              border-bottom-left-radius: calc(${card.radius} - 1px);
            `
        : css `
              border-bottom: ${card['border-width']} solid
                ${card['border-color']};
              border-top-left-radius: calc(${card.radius} - 1px);
              border-top-right-radius: calc(${card.radius} - 1px);
            `}
      }
    `}

    ${color}
    ${margins}
  `);
const Body = styled.div(({ theme: { olist: { components: { card }, }, }, }) => css `
    padding: ${card.padding};
  `);
const Image = styled.figure `
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;
const Footer = styled.div(({ theme: { olist: { components: { card }, }, }, }) => css `
    display: flex;
    column-gap: ${card.footer.gap};
    padding: ${card.footer.padding.vertical} ${card.footer.padding.horinzontal};

    border-top: ${card.footer.border.width} solid ${card.footer.border.color};
  `);
const Header = styled.div(({ theme: { olist: { components: { card }, }, }, }) => css `
    display: flex;
    column-gap: ${card.footer.gap};
    padding: ${card.footer.padding.vertical} ${card.footer.padding.horinzontal};

    border-bottom: ${card.footer.border.width} solid ${card.footer.border.color};
  `);

export { Body, CardComponent, Footer, Header, Image };
